import { App } from 'stores/StartupStore';
import { AxiosInstance } from 'axios';
import { IResult } from './Result';

export class StartupService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getAllApps = async (identityUrl: string) => {
    const response = await this.axiosInstance.get<IResult<App[]>>(`${identityUrl}/api/v1/me/apps`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(response.status === 500 ? 'There was an internal error while fetching list of apps.' : response.data.toString());
  };
}

export default StartupService;
